import React, { useState, useEffect } from 'react';
import logo from '../../assets/images/DLM-logo-shadow.png';
import imagesData from '../../assets/backgrounds/images.json';

const imageUrls = imagesData.images.map((image) =>
  require(`../../assets/backgrounds/${image}`)
);

export default function EmailSubmitPage() {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [backgroundImageIndex, setBackgroundImageIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);

  useEffect(() => {
    const changeBackground = () => {
      const nextIndex = (backgroundImageIndex + 1) % imageUrls.length;
      setOpacity(0);
      setTimeout(() => {
        setBackgroundImageIndex(nextIndex);
        setOpacity(1);
      }, 500);
    };

    const intervalId = setInterval(changeBackground, 10000);
    return () => clearInterval(intervalId);
  }, [backgroundImageIndex]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    setSuccessMessage('');
    try {
      // Simulating a successful email submission
      setIsLoading(false);
      setSuccessMessage('Please check your email for password reset instructions.');
      setShowConfirmation(true);
    } catch (err) {
      setErrorMessage('An error occurred. Please try again.');
      setIsLoading(false);
    }
  };

  const handleResend = () => {
    setResendDisabled(true);
    setTimeout(() => setResendDisabled(false), 15000);
  };

  const handleBack = () => {
    setShowConfirmation(false);
    setEmail('');
    setErrorMessage('');
    setSuccessMessage('');
  };

  return (
    <>
      <div
        className="fixed left-0 top-0 z-0 h-full w-full transition-opacity duration-1000"
        style={{
          backgroundImage: `url(${imageUrls[backgroundImageIndex]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: opacity,
        }}
      ></div>
      <div className="relative z-10 flex min-h-screen flex-col justify-center bg-opacity-75 py-12 sm:px-6 lg:px-8">
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
            {showConfirmation ? (
              <div className="text-center">
                <p className="text-lg font-medium text-gray-700">
                  {successMessage}
                </p>
                <div className="mt-6 space-y-4">
                  <button
                    onClick={handleResend}
                    className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    disabled={resendDisabled}
                  >
                    {resendDisabled ? 'Wait 15 seconds...' : 'Resend'}
                  </button>
                  <button
                    onClick={handleBack}
                    className="flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    Back
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                  <img
                    className="w-6/8 mx-auto my-20 mb-8 h-32"
                    src={logo}
                    alt="Logo"
                  />
                  <h2 className="mt-6 pb-10 text-center text-2xl font-bold text-gray-400">
                    Submit Your Email
                  </h2>
                  {errorMessage && (
                    <p className="mt-2 text-center text-sm text-red-600">
                      {errorMessage}
                    </p>
                  )}
                </div>

                <form className="space-y-8" onSubmit={handleSubmit}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Email Address
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        required
                        className="block w-full appearance-none rounded-md border border-gray-400 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      disabled={isLoading}
                    >
                      {isLoading ? 'Sending...' : 'Send'}
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
